import type { RouteRecordRaw } from "vue-router";
import { crudRoutes } from "./helpers/crudRoutes";

// Public routes — no auth required
export const signaturePlatformPublicRoutes: RouteRecordRaw[] = [
  {
    path: "/s/:token",
    name: "PublicDocumentView",
    component: () =>
      import("@/views/SignaturePlatform/PublicDocument/PublicDocumentView.vue"),
    props: true,
  },
  {
    path: "/document-submitted-successfully",
    name: "SubmissionSuccess",
    component: () =>
      import("@/views/SignaturePlatform/PublicDocument/SubmissionSuccess.vue"),
  },
  {
    path: "/document-closed",
    name: "DocumentClosed",
    component: () =>
      import("@/views/SignaturePlatform/PublicDocument/DocumentClosed.vue"),
  },
  {
    path: "/request-closed-info",
    name: "RequestClosedInfo",
    component: () =>
      import("@/views/SignaturePlatform/PublicDocument/RequestClosedInfo.vue"),
  },
  {
    path: "/request-cancelled-info",
    name: "RequestCancelledInfo",
    component: () =>
      import("@/views/SignaturePlatform/PublicDocument/RequestCancelledInfo.vue"),
  },
];

// Auth routes — inside the auth shell (requiresAuth inherited from parent)
export const signaturePlatformAuthRoutes: RouteRecordRaw[] = [
  // Signature Platform Dashboard
  {
    path: "/sign-dashboard",
    name: "sign-dashboard",
    component: () =>
      import("@/views/SignaturePlatform/Dashboard/Dashboard.vue"),
  },
  // Redirects for removed routes
  { path: "/get-signatures", redirect: "/sign-dashboard" },
  { path: "/stepper", redirect: "/sign-dashboard" },
  { path: "/manage-signatures", redirect: "/documents" },
  { path: "/manage-signatures/edit/:email", redirect: "/documents" },
  // Leave Widget related routes
  {
    path: "/leave-widget",
    name: "leave-widget",
    component: () => import("@/views/Finance/Finance.vue"),
    props: () => ({ mode: "list" }),
  },
  {
    path: "/leave-widget/new",
    name: "leave-widget-new",
    component: () => import("@/views/Finance/Finance.vue"),
    props: () => ({ mode: "create" }),
  },
  {
    path: "/leave-widget/:id/edit",
    name: "leave-widget-edit",
    component: () => import("@/views/Finance/Finance.vue"),
    props: (route) => ({ mode: "edit", id: route.params.id }),
  },
  // Documents
  {
    path: "/documents",
    name: "Documents",
    component: () =>
      import("@/views/SignaturePlatform/Documents/Documents.vue"),
  },
  // External Contacts
  ...crudRoutes({
    path: "external-contacts",
    listComponent: () =>
      import("@/views/ExternalContacts/ExternalContacts.vue"),
    formComponent: () =>
      import("@/views/ExternalContacts/ExternalContactForm.vue"),
  }),
];
